import { Component, Inject, Injector, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { StaggeredProductDetailsDtoResponse } from 'app/core/models/staggered-product-details.dto-response';
import { WarningsSetupService } from 'app/shared/notes/warnings-setup.service';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { Constants, Positions, AccessoryCategory, PositionValues } from '../../core/Constants';
import { BRAND } from '../../core/DI';
import { GenericSummaryCardDtoResponse } from '../../core/models/generic-summary-card.dto-response';
import { ImageDetails } from '../../core/models/image-details.dto-response';
import { MakeYearModel } from '../../core/models/make-year-model.model';
import { PackageBuilderSummaryProduct } from '../../core/models/package-builder-summary-product.model';
import { ProductCardDtoResponse } from '../../core/models/product-card-dto-response';
import { ProductDetailsModel } from '../../core/models/product-details-model.model';
import { ProductDetailsDtoResponse } from '../../core/models/product-details.dto-response';
import { ProductIdsModel } from '../../core/models/product-ids.model';
import { Product } from '../../core/models/product.model';
import { RouteContext } from '../../core/models/route-context';
import { User } from '../../core/User';
import { PackageBuilderComponent } from '../../package-builder/package-builder.component';
import { PackageBuilderService } from '../../package-builder/package-builder.service';
import { HardwareService } from '../../shared/hardware.service';
import { Helper } from '../../shared/helper';
import { IProductService } from '../../shared/iproduct.service';
import { LabourModel } from '../../shared/notes/models/labour-model';
import { ProductsNotesModel } from '../../shared/notes/models/products-notes-model';
import { NotesConstants } from '../../shared/notes/notes.constants';
import { ProductNotesService } from '../../shared/notes/product-notes.service';
import { ProductZoomService } from '../../shared/notes/product-zoom.service';
import { NormalizeQtyPipe } from '../../shared/pipe/normalize-qty.pipe';
import { SearchTextService } from '../../shared/search-text.service';
import { SettingService } from '../../shared/setting.service';
import { TireService } from '../../shared/tire.service';
import { WheelService } from '../../shared/wheel.service';
import { ProductDetailsBaseComponent } from '../product-details.base-component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LabourDetailsDtoResponse } from 'app/core/models/labour-details.dto-response';
import { ProductCardDetailsDtoResponse } from 'app/core/models/product-card-details.dto-response';
import { ProductDetail } from 'app/core/models/product-card-detail.dto-response';
import { InventoryDetailDtoResponse, InventoryDtoResponse } from 'app/core/models/inventory.dto-response';
import { ProductConfiguratorModalService } from '../../shared/products/product-configurator-modal/product-configurator-modal.service'
import { AddToCartService } from '../../shared/add-to-cart.service';
import { LeadTimeDtoResponse } from '../../core/models/lead-time-dto-response';

@Component({
  selector: 'app-product-details-modal',
  templateUrl: './product-details-modal.component.html',
  styleUrls: ['./product-details-modal.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class ProductDetailsModalComponent extends ProductDetailsBaseComponent implements OnInit, OnDestroy {
  @Input() card: GenericSummaryCardDtoResponse;
  @Input() product: ProductCardDtoResponse;
  @Input() anchorClass = '';
  @Input() defaultWarehouse = '';
  @Input() rearProduct: ProductCardDtoResponse;
  @Input() mtlWheelDrillLeadTime: LeadTimeDtoResponse;

  closeResult: string;
  public modalInstance;
  showWaiting: boolean;
  productService: IProductService;
  hardwareService: IProductService;
  productType: string;
  currentImage: string;
  currentImageMailToURL: string;
  imageList: string[] = [];
  eachText: string;
  isInPackageBuilder: boolean;
  isByVehicle: boolean;
  context: RouteContext = RouteContext.NONE;
  productModel: ProductDetailsModel = null;
  rearProductModel: ProductDetailsModel = null;
  isInB2b: boolean;
  brand: string;
  isCurrentlySelectedProduct = false;
  wheelType: boolean;
  safeURL: SafeUrl;
  regexp: RegExp;
  defaultQty: number;
  maxValue: number;
  displayConfigurator = false;
  mym: MakeYearModel;
  brandLogoURL: string;
  winterContext = false;
  private handler;
  mobileBrowser = false;

  subs: Subscription[] = [];

  constructor(private route: ActivatedRoute,
    private router: Router,
    private injector: Injector,
    private modalService: NgbModal,
    private productNotesService: ProductNotesService,
    private translateService: TranslateService,
    private productZoomService: ProductZoomService,
    private sanitizer: DomSanitizer,
    private packageBuilderService: PackageBuilderService,
    private normalizeQtyPipe: NormalizeQtyPipe,
    private settingService: SettingService,
    private deviceService: DeviceDetectorService,
    private addToCartService: AddToCartService,
    @Inject(BRAND) brand: string) {
    super();
    this.brand = brand;
    this.isInB2b = brand === Constants.BRAND_B2B;
    this.winterContext = route.snapshot.queryParams['season'] === "winter";
    this.isMobileBrowser();
  }

  ngOnInit(): void {
    this.regexp = new RegExp(Constants.ICONFIGURATOR_REGEX);
  }

  setupProductService(): void {
    switch (this.productType) {
      case Constants.PRODUCT_TYPE_ANY:
        this.productService = this.injector.get<SearchTextService>(SearchTextService);
        break;
      case Constants.PRODUCT_TYPE_WHEEL:
        this.productService = this.injector.get<WheelService>(WheelService);
        this.hardwareService = this.injector.get<HardwareService>(HardwareService);
        this.wheelType = true;
        break;
      case Constants.PRODUCT_TYPE_TIRE:
        this.productService = this.injector.get<TireService>(TireService);
        break;
      case Constants.PRODUCT_TYPE_HARDWARE:
        this.productService = this.injector.get<HardwareService>(HardwareService);
        break;
    }
  }

  open(content) {
    if (this.product.longSKU.startsWith(Constants.CUSTOMER_SIZE)) return;
    this.getProductDetails();
    this.modalInstance = this.modalService.open(content, { windowClass: 'app-product-details-modal' });
    this.modalInstance.result.then((result) => {
      this.closeResult = 'Closed with: ${result}';
    }, (reason) => {
      this.closeResult = 'Dismissed ${this.getDismissReason(reason)}';
    });
  }

  getProductDetails(): void {
    this.showWaiting = true;
    this.displayConfigurator = false;

    //this.route.data.take(1).subscribe(data => {
    this.subs.push(this.route.data.pipe(take(1)).subscribe(data => {
      this.productType = data.productType;
      this.eachText = `FC.Display${data.productType}Details.Each`;
      this.context = data.context;
      this.isInPackageBuilder = this.context === RouteContext.PACKAGE_BUILDER;
      this.isByVehicle = this.context === RouteContext.SEARCH_BY_VEHICLE;
      this.setupProductService();

    }, Helper.handleError));

    this.productModel = new ProductDetailsModel();
    this.productModel.id = this.product.longSKU;
    this.defaultWarehouse = this.product.defaultWarehouse;

    if (this.rearProduct !== null) {
      this.rearProductModel = new ProductDetailsModel();
      this.rearProductModel.id = this.rearProduct.longSKU;
      Helper.SkuList.setIndex(`${this.product.longSKU}_${this.rearProduct.longSKU}`);
    }
    else
      Helper.SkuList.setIndex(this.product.longSKU);

    this.subs.push(this.route.queryParamMap.subscribe(queryParams => {

      this.mym = Helper.extractMakeYearModelFromRouteParam(queryParams);

      let wtIds = new ProductIdsModel();

      this.packageBuilderService = this.injector.get<PackageBuilderService>(PackageBuilderService);
      if (Helper.isProductTypePreferenceTire())
        wtIds = this.packageBuilderService.getTireIds();
      else
        wtIds = this.packageBuilderService.getWheelIds();
      // djb:ngOnDestroy?
      if (this.mym.isValid) {
        if (this.productType === Constants.PRODUCT_TYPE_WHEEL)
          this.mym.isSummerSeason = !this.product.isWinterWheel;

        if (this.rearProductModel) {
          this.subs.push(this.productService.getStaggeredProductDetails(`${this.productModel.id}_${this.rearProductModel.id}`, this.mym, wtIds.front, wtIds.rear).subscribe(
            responseProduct => {
              if (responseProduct === null) {
                this.rejectProduct();
                return;
              }
              this.setupStaggeredProduct(responseProduct);
            }, Helper.handleError));
        } else {
          this.subs.push(this.productService.getProductDetails(this.productModel.id, this.mym, wtIds.front, wtIds.rear).subscribe(
            responseProduct => {
              if (responseProduct === null) {
                this.rejectProduct();
                return;
              }
              this.setupProduct(responseProduct);
            }, Helper.handleError));
        }
      } else {
        if (this.rearProductModel) {
          this.subs.push(this.productService.getStaggeredProductDetailsBySpecs(`${this.productModel.id}_${this.rearProductModel.id}`).subscribe(
            responseProduct => {
              if (responseProduct === null) {
                this.rejectProduct();
                return;
              }
              this.setupStaggeredProduct(responseProduct);
            }, Helper.handleError));
        } else {
          this.subs.push(this.productService.getProductDetailsBySpecs(this.productModel.id).subscribe(
            responseProduct => {
              if (responseProduct === null) {
                this.rejectProduct();
                return;
              }
              this.setupProduct(responseProduct);
            }, Helper.handleError));
        }
      }
    }, Helper.handleError));
  }

  rejectProduct() {
     //alert("no data available for id: " + this.productModel.id);
    this.showWaiting = false;
  }

  setupProduct(responseProduct: ProductDetailsDtoResponse): void {
    super.addSkuToDetails(responseProduct);
    this.productModel.product = responseProduct;
    this.getImageList(this.productModel.product);
    this.brandLogoURL = Helper.getLogoURL(this.productModel.product.productType, this.productModel.product.productBrand);
    this.setQuantityInformation();
    this.setupConfigurator(responseProduct.iconUrl);
    if (this.isInPackageBuilder) {
      this.checkIfProductSelected();
    }
    this.showWaiting = false;
    document.onkeydown = checkKey;
    function checkKey(e) {
      e = e || window.event;
      if (e.keyCode == '37') {
        // left arrow
        $('.arrow-prev button').click();
      }
      else if (e.keyCode == '39') {
        // right arrow
        $('.arrow-next button').click();
      }

    }

  }

  setupStaggeredProduct(responseProduct: StaggeredProductDetailsDtoResponse): void {
    super.addSkuToDetails(responseProduct.frontProductDetailsDto);
    super.addSkuToDetails(responseProduct.rearProductDetailsDto);

    this.productModel.product = responseProduct.frontProductDetailsDto;
    this.rearProductModel.product = responseProduct.rearProductDetailsDto;

    this.getImageList(this.productModel.product);
    this.brandLogoURL = Helper.getLogoURL(this.productModel.product.productType, this.productModel.product.productBrand);
    this.setQuantityInformation();
    this.setupConfigurator(responseProduct.frontProductDetailsDto.iconUrl);
    if (this.isInPackageBuilder) {
      this.checkIfProductSelected();
    }
    this.showWaiting = false;
  }

  private setProductDefaultQuantity() {
    switch (this.card.frontProduct.accessoryType) {
      case AccessoryCategory.BilletWheelAdapters:
      case AccessoryCategory.Emblem:
      case AccessoryCategory.HubRings:
      case AccessoryCategory.WheelSpacers:
      case AccessoryCategory.TPMS:
        this.defaultQty = 4;
        break;
      case AccessoryCategory.SpecialValves:
      case AccessoryCategory.TireValves:
      case AccessoryCategory.ValveCap:
        this.defaultQty = 4;

        if (this.card.frontProduct.qtyBaseUOfM > 1)
          this.defaultQty = 1;

        break;
      case AccessoryCategory.Bolts:
      case AccessoryCategory.Nuts:
      case AccessoryCategory.NutsET:
        this.defaultQty = 20;
        break;
    }

    if (this.card.rearProduct == null && (this.card.productTypeWarning === 'Tire' || this.card.productTypeWarning === 'Wheel'))
      this.defaultQty = 4;
  }

  setQuantityInformation(): void {

    //set max selectable quantity for product
    if (this.defaultWarehouse === "MTL") {
      this.maxValue = this.productModel.product.inventory.onHandQtyMtl;
    } else {
      if (this.productModel.product.inventory.onHandQtyMtl > this.productModel.product.inventory.onHandQtyCal) {
        this.maxValue = this.productModel.product.inventory.onHandQtyMtl;
      } else {
        this.maxValue = this.productModel.product.inventory.onHandQtyCal;
      }
    }

    //set a default selected quantity
    switch (this.productModel.product.productType) {
      case "Wheel":
        this.defaultQty = this.rearProduct !== null ? 2 : 4;
        break;
      case "Tire":
        this.defaultQty = this.rearProduct !== null ? 2 : 4;
        break;
      default:
        this.defaultQty = 1;
        break;
    }

    this.setProductDefaultQuantity();

    this.productModel.qty = this.defaultQty;
    if (this.rearProductModel)
      this.rearProductModel.qty = this.defaultQty;



   var existCondition = setInterval(function () {
      if ($('.inv-label').length) {
        clearInterval(existCondition);
        $('.mtl-inv-front .inv-label').each(function () {
          var label = $(this).text().split(" ").join("").replace('(', '').replace(')', '');
          $(this).next('.inv-item').addClass('inv-item_' + label);
          $(this).next('').next('.rear-col').addClass('inv-item_' + label);
        });

        $('.mtl-inv-rear .inv-item').each(function () {
          var category = $(this).prev('.inv-label').text().split(" ").join("").replace('(', '').replace(')', '');
          var invVal = $(this).text();
          if ($(this).hasClass('stockLabel-0')) {
            $('.mtl-inv-front .rear-col.inv-item_' + category).addClass('stockLabel-0').text(invVal);
          }
          else {
            $('.mtl-inv-front .rear-col.inv-item_' + category).text(invVal);
          }
        });


        $('.cgy-inv-front .inv-label').each(function () {
          var label = $(this).text().split(" ").join("");
          $(this).next('.inv-item').addClass('inv-item_' + label);
          $(this).next('').next('.rear-col').addClass('inv-item_' + label);
        });

        $('.cgy-inv-rear .inv-item').each(function () {
          
          var category = $(this).prev('.inv-label').text().split(" ").join("");
          var invVal = $(this).text();
          if ($(this).hasClass('stockLabel-0')) {
            $('.cgy-inv-front .rear-col.inv-item_' + category).addClass('stockLabel-0').text(invVal);
          }
          else {
            $('.cgy-inv-front .rear-col.inv-item_' + category).text(invVal);
          }
          
        });

      }
    }, 100);

  }

  checkIfProductSelected(): void {
    const packageBuilderComponent = this.injector.get<PackageBuilderComponent>(PackageBuilderComponent);
    const flowStatus = this.packageBuilderService.getPackageBuilderFlowStatus();
    if (flowStatus === 2) {
      if (packageBuilderComponent.frontSelections.selectedWheel != null &&
        packageBuilderComponent.rearSelections.selectedWheel == null &&
        packageBuilderComponent.frontSelections.selectedWheel.longSKU === this.productModel.product.longSKU) {
        this.isCurrentlySelectedProduct = true;
      } else if (packageBuilderComponent.frontSelections.selectedWheel != null &&
        packageBuilderComponent.rearSelections.selectedWheel != null &&
        packageBuilderComponent.frontSelections.selectedWheel.longSKU === this.productModel.product.longSKU &&
        packageBuilderComponent.rearSelections.selectedWheel.longSKU === this.rearProductModel.product.longSKU) {
        this.isCurrentlySelectedProduct = true;
      }
    } else if (flowStatus === 3) {
      if (packageBuilderComponent.frontSelections.selectedTire != null &&
        packageBuilderComponent.rearSelections.selectedTire == null &&
        packageBuilderComponent.frontSelections.selectedTire.longSKU === this.productModel.product.longSKU) {
        this.isCurrentlySelectedProduct = true;
      } else if (packageBuilderComponent.frontSelections.selectedTire != null &&
        packageBuilderComponent.rearSelections.selectedTire != null &&
        packageBuilderComponent.frontSelections.selectedTire.longSKU === this.productModel.product.longSKU &&
        packageBuilderComponent.rearSelections.selectedTire.longSKU === this.rearProductModel.product.longSKU) {
        this.isCurrentlySelectedProduct = true;
      }
    }
  }

  deselectProduct(): void {
    const packageBuilderService = this.injector.get<PackageBuilderService>(PackageBuilderService);
    if (!(packageBuilderService)) {
      throw new Error('Package builder context: PackagBuilderService is missing. Did you forget to provide the service ?');
    }

    this.isCurrentlySelectedProduct = false;
    const tireFirst = Helper.isProductTypePreferenceTire();
    switch (packageBuilderService.getPackageBuilderFlowStatus()) {
      case 2:
        if (!tireFirst)
          packageBuilderService.clear();
        else
          packageBuilderService.deselectWheels();
        break;
      case 3:
        if (!tireFirst)
          packageBuilderService.deselectTires();
        else
          packageBuilderService.clear();
        break;
    }
  }

  addToPackageBuilder(): void {
    switch (this.productType) {
      case Constants.PRODUCT_TYPE_HARDWARE:
        alert('todo: add hardware to builder');
        break;
      case Constants.PRODUCT_TYPE_WHEEL:
        this.addProductToBuilder();
        break;
      case Constants.PRODUCT_TYPE_TIRE:
        this.addProductToBuilder();
        break;
      default:
        break;
    }
  }

  addProductToBuilder() {
    this.productNotesService.validateProductWarningsAck(
      this.productModel.product.warningNotes,
      null,
      NotesConstants.CONTINUE_ACTION_RESOURCE_KEY_PACKAGE_BUILDER,
      NotesConstants.CANCEL_ACTION_RESOURCE_KEY_PACKAGE_BUILDER)
      .then(ack => {
        if (ack) {
          //if (this.productModel.product.labours && this.productModel.product.labours.length > 0) {

          //  const labourModels = this.getLaboursModel();
          //  this.productNotesService.openNoteModal(labourModels, null)
          //    .then((results: ProductsNotesModel[]) => {
          //      const labours: Product[] = [];
          //      let found: LabourModel;

          //      for (const result of results) {
          //        if (result.isSelected
          //          && (found = labourModels.find(l => l.labour.type === result.type))) {
          //          labours.push(Helper.labourModelToProduct(found));
          //        }
          //      }

          //      this.showWaiting = true;
          //      // product, selected productModel...
          //      // Maybe refactor the selectProduct
          //      this.selectProduct(labours);
          //    });
          //} else {
            this.selectProduct();
          //}
        }
      });
  }
  
  addProductWarningNote(warningVar: string) {
    if (this.productModel.product.warningNotes == null) {
      this.productModel.product.warningNotes = [];
    }
    this.productModel.product.warningNotes.push(this.translateService.instant(warningVar));
  }

  changeImage(imgLink: string) {
    this.currentImage = imgLink;
    const subject = encodeURI(`Fastco Canada | ${this.productModel.product.productBrand} ${this.product.longSKU}`);
    this.currentImageMailToURL = `mailto:?subject${subject}=&body=${imgLink}`;
  }

  getAllIcons(): ImageDetails[] {
    return Helper.removeImageDuplicates(this.productModel.product.icons);
  }

  getImageList(product: ProductDetailsDtoResponse): void {
    //if (product !== null && product !== undefined) {
    if (product.productImages) {
      this.imageList = product.productImages.map(pi => pi.imageUrl); //mike
      //this.imageList = product.productImages.map(pi => pi.thumbnailUrl); //mike
    }
    else
      this.imageList = [];
   if (this.imageList.length > 0) {
      this.currentImage = this.imageList[0];
      const subject = encodeURI(`Fastco Canada | ${this.productModel.product.productBrand} ${this.product.longSKU}`);
      this.currentImageMailToURL = `mailto:?subject=${subject}&body=${this.imageList[0]}`;
    }
    //}
  }

  getLaboursModel(): LabourModel[] {
    const packageBuilderService = this.injector.get<PackageBuilderService>(PackageBuilderService);
    return Helper.getLaboursModel(packageBuilderService, this.productModel.product.labours, this.productModel.qty);
  }

  getValue(product: ProductDetailsDtoResponse, label: string) {
    if (product.details.some(d => d.label === label))
      return product.details.find(d => d.label === label).value;
    return 'N/A';
  }

  getTitle() {
    if (this.rearProductModel)
      return `${this.productModel.product.title} / ${this.rearProductModel.product.title}`;
    return this.productModel.product.title;
  }

  getTooltip(product: ProductDetailsDtoResponse, label: string) {
    if (product.details.some(d => d.label === label))
      return product.details.find(d => d.label === label).detailTooltip;
    return 'N/A';
  }

  labourSummary(labours: Product[]): PackageBuilderSummaryProduct[] {
    return Helper.getLabourSummaries(labours, this.productModel.product.labours);
  }

  openProductZoomDialog(): void {
    this.productZoomService.showProductZoom(this.currentImage, 'FC.ProductWarningsNotes.Continue', 'pb-product-zoom');
  }

  productSummary(): PackageBuilderSummaryProduct {
    const summaryProduct = new PackageBuilderSummaryProduct();
    //summaryProduct.imgURL = this.productModel.product.productImages[0].thumbnailUrl;
    summaryProduct.imgURL = this.productModel.product.productImages[0].imageUrl;//mike
    if (this.productType === Constants.PRODUCT_TYPE_WHEEL) {
      //const finishDetail = this.productModel.product.details.find(function (element) {
      //  return element.label === Constants.DetailLabelFinish;
      //});
      //JD
      const offset = this.productModel.product.details.find(d => d.label === Constants.OFFSET_DETAIL_LABEL).value;
      summaryProduct.offset = Number(offset);

      summaryProduct.description = this.productModel.product.title + '\n' + this.productModel.product.description;//this.productModel.product.title + '\n' + finishDetail.value;
    } else if (this.productType === Constants.PRODUCT_TYPE_TIRE) {
      const sizeDetail = this.productModel.product.details.find(function (element) {
        return element.label === Constants.DESCRIPTION_DETAIL_LABEL;
      });
      //const categoryDetail = this.productModel.product.details.find(function (element) {
      //  return element.label === Constants.CATEGORY_DETAIL_LABEL;
      //});
      summaryProduct.description = this.productModel.product.title + '\n' + sizeDetail.value;// + '\n' + categoryDetail.value;
    }
    summaryProduct.shortSKU = this.productModel.product.shortSKU;
    summaryProduct.longSKU = this.productModel.product.longSKU;
    summaryProduct.qty = this.productModel.qty;
    summaryProduct.retailPrice = Number(this.productModel.product.retailPrice);
    summaryProduct.customerPrice = Number(this.productModel.product.customerPrice);
    summaryProduct.landedCost = Number(this.productModel.product.landedCost);
    summaryProduct.totalPrice = summaryProduct.customerPrice * summaryProduct.qty;
    summaryProduct.warningNotes = this.productModel.product.warningNotes;
    summaryProduct.tirePressure = this.product.tirePressure;
    summaryProduct.inventory = this.product.inventory;
    summaryProduct.pairNo = this.card.pairNo;
    summaryProduct.isConcept = this.packageBuilderService.isProductConcept(this.product.details.details);
    summaryProduct.productStatus = this.product.productStatus;
    summaryProduct.onHandDetails = this.productModel.product.onHandDetails;
    summaryProduct.isOnSpecial = this.productModel.product.isSpecial;
    summaryProduct.dealerCost = Number(this.productModel.product.dealerCost);
    if (this.card.frontProduct.position !== null)
      summaryProduct.position = this.card.frontProduct.position.toString();
  return summaryProduct;
  }

  rearProductSummary(): PackageBuilderSummaryProduct {
    const summaryProduct = new PackageBuilderSummaryProduct();
    //summaryProduct.imgURL = this.rearProductModel.product.productImages[0].thumbnailUrl;
    summaryProduct.imgURL = this.rearProductModel.product.productImages[0].imageUrl;//mike
    if (this.productType === Constants.PRODUCT_TYPE_WHEEL) {
      //const finishDetail = this.rearProductModel.product.details.find(function (element) {
      //  return element.label === Constants.DetailLabelFinish;
      //});
      //JD
      const offset = this.rearProductModel.product.details.find(d => d.label === Constants.OFFSET_DETAIL_LABEL).value;
      summaryProduct.offset = Number(offset);

      summaryProduct.description = this.rearProductModel.product.title + '\n' + this.rearProductModel.product.description;//this.rearProductModel.product.title + '\n' + finishDetail.value;
    } else if (this.productType === Constants.PRODUCT_TYPE_TIRE) {
      const sizeDetail = this.rearProductModel.product.details.find(function (element) {
        return element.label === Constants.DESCRIPTION_DETAIL_LABEL;
      });
      summaryProduct.description = this.rearProductModel.product.title + '\n' + sizeDetail.value;
    }
    summaryProduct.shortSKU = this.rearProductModel.product.shortSKU;
    summaryProduct.longSKU = this.rearProductModel.product.longSKU;
    summaryProduct.qty = this.rearProductModel.qty;
    summaryProduct.retailPrice = Number(this.rearProductModel.product.retailPrice);
    summaryProduct.customerPrice = Number(this.rearProductModel.product.customerPrice);
    summaryProduct.landedCost = Number(this.rearProductModel.product.landedCost);
    summaryProduct.totalPrice = summaryProduct.customerPrice * summaryProduct.qty;
    summaryProduct.warningNotes = this.rearProductModel.product.warningNotes;
    summaryProduct.tirePressure = this.rearProduct.tirePressure;
    summaryProduct.inventory = this.rearProduct.inventory;
    summaryProduct.pairNo = this.card.pairNo;
    summaryProduct.isConcept = this.packageBuilderService.isProductConcept(this.rearProduct.details.details);
    summaryProduct.productStatus = this.rearProduct.productStatus;
    summaryProduct.onHandDetails = this.rearProductModel.product.onHandDetails;
    summaryProduct.isOnSpecial = this.rearProductModel.product.isSpecial;
    summaryProduct.dealerCost = Number(this.rearProductModel.product.dealerCost);
    if (this.card.rearProduct.position !== null)
      summaryProduct.position = this.card.rearProduct.position.toString();
    return summaryProduct;
  }

  async selectProduct(labours: Product[] = null, packageBuilderService: PackageBuilderService = null) {
    this.showWaiting = true;
    this.deselectProduct();
    if (packageBuilderService === null) {
      packageBuilderService = this.injector.get<PackageBuilderService>(PackageBuilderService);
    }

    if (!(packageBuilderService)) {
      throw new Error('Package builder context: PackagBuilderService is missing. Did you forget to provide the service ?');
    }

    if (labours && labours.length > 0) {
      packageBuilderService.addLabours(labours, this.labourSummary(labours), Positions.FRONT);

    }

    //Setup warning modal confirmations
    let warningsList = null;
    const url = decodeURIComponent(this.router.url);
    WarningsSetupService.setupWarnings(this.packageBuilderService, this.translateService, this.settingService, this.productModel.qty, this.rearProductModel ? this.rearProductModel.qty : null, this.card, this.context === RouteContext.PACKAGE_BUILDER || this.context === RouteContext.SEARCH_BY_VEHICLE || this.context === RouteContext.SEARCH_BY_VEHICLE_FOR_ACCESSORY, url.includes("search-by-vehicle/wheel-search"), this.mtlWheelDrillLeadTime).then(value => {
      warningsList = value;

      let productSummary = this.productSummary();
      let rearProductSummary = null;
      if (this.rearProduct)
        rearProductSummary = this.rearProductSummary();

      if (this.winterContext && (this.card.productType.toLowerCase() === 'wheel' || this.card.productTypeWarning.toLowerCase() === 'wheel')) {
        let isSummerWheel = !this.card.frontProduct.isWinterWheel;

        if (this.card.rearProduct !== null)
          isSummerWheel = isSummerWheel || !this.card.rearProduct.isWinterWheel;

        if (isSummerWheel)
          warningsList.warnings.push(this.translateService.instant('FC.Popup.ShowSummerWheels.Warning'));
      }

      packageBuilderService.validateWarnings(warningsList.warnings).then(validated => {
        let proceed: boolean = validated;
        if (validated && warningsList.proceedToNextStep) {
          if (productSummary.warningNotes == null) {
            productSummary.warningNotes = [];
          }
          if (this.card.frontProduct.warningNotes != null) {
            this.card.frontProduct.warningNotes.forEach(note => {
              if (!productSummary.warningNotes.some(n => n === note))
                productSummary.warningNotes.push(note);
            });
          }

          let frontFreeWMB: boolean = this.productModel.product.freeWMB;
          if (frontFreeWMB && this.productType === Constants.PRODUCT_TYPE_TIRE) {
            if (this.card.frontProduct.defaultWarehouse === "MTL")
              frontFreeWMB = this.productModel.qty < this.card.frontProduct.inventory.onHandQtyMtl;
            else
              frontFreeWMB = this.productModel.qty < this.card.frontProduct.inventory.onHandQtyCal;
          }
          const product = new Product({
            id: this.productModel.product.longSKU,
            quantity: this.productModel.qty,
            warningNotes: this.card.frontProduct.warningNotes,//this.productModel.product.warningNotes,
            type: this.productType,
            tirePressure: this.product.tirePressure,
            pairNo: this.productModel.product.pairNo,
            freeWMB: frontFreeWMB,
            wmbRequired: this.card.wmbRequired
          });
          if (this.card.frontProduct.position !== null)
            product.position = this.card.frontProduct.position.toString();
          let rearProd = null;
          if (this.rearProduct) {
            let rearFreeWMB: boolean = this.rearProductModel.product.freeWMB;
            if (rearFreeWMB && this.productType === Constants.PRODUCT_TYPE_TIRE) {
              if (this.card.rearProduct.defaultWarehouse === "MTL")
                rearFreeWMB = this.rearProductModel.qty < this.card.rearProduct.inventory.onHandQtyMtl;
              else
                rearFreeWMB = this.rearProductModel.qty < this.card.rearProduct.inventory.onHandQtyCal;
            }
            rearProd = new Product({
              id: this.rearProductModel.product.longSKU,
              quantity: this.rearProductModel.qty,
              warningNotes: this.card.rearProduct.warningNotes,//this.rearProductModel.product.warningNotes,
              type: this.productType,
              tirePressure: this.rearProduct.tirePressure,
              pairNo: this.rearProductModel.product.pairNo,
              freeWMB: rearFreeWMB,
              wmbRequired: this.card.wmbRequired
            });
            if (this.card.rearProduct.position !== null)
              rearProd.position = this.card.rearProduct.position.toString();
            if (rearProductSummary.warningNotes == null) {
              rearProductSummary.warningNotes = [];
            }
            if (this.card.rearProduct.warningNotes != null) {
              this.card.rearProduct.warningNotes.forEach(note => {
                if (!rearProductSummary.warningNotes.some(n => n === note))
                  rearProductSummary.warningNotes.push(note);
              });
            }
          }

          if (product.type === Constants.PRODUCT_TYPE_WHEEL) {
            let extCapRequired: boolean = this.card.frontProduct.extensionCapRequired || (this.card.rearProduct != null && this.card.rearProduct.extensionCapRequired);

            if (extCapRequired) {
              proceed = false;
              let extensionCapWarning: string[];
              let extensionCapPrice = this.card.frontProduct.extensionCapPrice.toString();

              const culture = sessionStorage.getItem('currentCulture').toLowerCase();
              if (culture === 'fr-ca')
                extensionCapPrice = extensionCapPrice.replace('.', ',');

              extensionCapWarning = [`<div class="capsWarning">${this.translateService.instant("FC.Popup.ExtensionCapOrNot").replace('{extCapPrice}', extensionCapPrice)}</div>`];

              this.productNotesService.validateProductWarningsAckNormalPopup(extensionCapWarning,
                null,
                "",
                "").then(ack => {
                  if (ack) {
                    sessionStorage.setItem("ExtensionCap", "yes"); 
                    sessionStorage.setItem("ExtensionCapRemovedByUser", "no");

                    this.selectProductWheelStep(packageBuilderService);

                    this.selectProductStep2(
                      packageBuilderService,
                      product,
                      productSummary,
                      rearProd,
                      rearProductSummary);
                  }
                  else {
                    sessionStorage.setItem("ExtensionCap", "no");
                    sessionStorage.setItem("ExtensionCapRemovedByUser", "no");
                  }
                });
            }
            else {
              this.selectProductWheelStep(packageBuilderService);
            }
          } else if (product.type === Constants.PRODUCT_TYPE_TIRE) {
            if (this.card.frontProduct.summerOrWinterTire === "All Season" && this.winterContext) {
              const note = packageBuilderService.getTranslatedNote('FC.ProductWarningsNotes.AllSeasonTireForWinter');
              if (product.warningNotes == null) {
                product.warningNotes = [];
              }
              product.warningNotes.push(note);
              if (productSummary.warningNotes == null) {
                productSummary.warningNotes = [];
              }
              productSummary.warningNotes.push(note);
            }
            if (this.card.frontProduct.studdable.toLowerCase() === "yes" && this.card.frontProduct.labours.length > 0 && this.card.frontProduct.labours.find(l => l.type === Constants.LABOUR_TYPE_STUDDING))
              packageBuilderService.tireStuddingAvailable = true;
            else
              packageBuilderService.tireStuddingAvailable = false;
            packageBuilderService.navigateToTires();
          }

          if (proceed) {
            this.selectProductStep2(
              packageBuilderService,
              product,
              productSummary,
              rearProd,
              rearProductSummary);
          }

          this.modalInstance.close('added to builder');

        } else {
          this.showWaiting = false;
        }
      });
    });

  }

  selectProductWheelStep(packageBuilderService: PackageBuilderService) {
    packageBuilderService.wheelIsDirectFit = this.productModel.product.isDirectFit && (this.rearProductModel == null || this.rearProductModel.product.isDirectFit);
    packageBuilderService.wheelIsAggressive = this.productModel.product.isAggressiveFitment && (this.rearProductModel == null || this.rearProductModel.product.isAggressiveFitment);
    packageBuilderService.wheelIsSteel = Helper.isSteelProduct(this.card.frontProduct.details);
    packageBuilderService.wheelIsOpenEnded = this.card.frontProduct.openEnded === 1;
    packageBuilderService.wheelBrand = this.brand;
  }

  selectProductStep2(packageBuilderService: PackageBuilderService, frontProduct: any, frontSummaryProduct: any, rearProduct: any, rearSummaryProduct: any) {
    packageBuilderService.addProduct(
      frontProduct,
      frontSummaryProduct,
      rearProduct,
      rearSummaryProduct,
      false, frontProduct.type
    );
    this.addLabourCards();
  }

  async addLabourCards() {
    if (this.card.frontProduct.labours != null) {
      for (let i = 0; i < this.card.frontProduct.labours.length; i++) {
        let labour = this.card.frontProduct.labours[i];
        if (labour.type === Constants.LABOUR_TYPE_STUDDING && this.card.frontProduct.studdable.toLowerCase() === "yes") {
          if (this.card.rearProduct && this.card.rearProduct.studdable.toLowerCase() === "yes" &&
            i <= this.card.rearProduct.labours.length - 1 && labour.type === this.card.rearProduct.labours[i].type &&
            labour.details.id !== this.card.rearProduct.labours[i].details.id) {
            this.addStuddingCard(labour.details, this.card.rearProduct.labours[i].details);
          }
          else {
            this.addStuddingCard(labour.details, null);
          }
        }
        //if (labour.type === Constants.LABOUR_TYPE_MOUNTING_AND_BALANCING) {
        //  if (this.card.rearProduct &&
        //    i <= this.card.rearProduct.labours.length - 1 && labour.type === this.card.rearProduct.labours[i].type &&
        //    labour.details.id !== this.card.rearProduct.labours[i].details.id) {
        //    this.addInstallationCard(labour.details, this.card.rearProduct.labours[i].details);
        //  }
        //  else {
        //    this.addInstallationCard(labour.details, null);
        //  }
        //}
      }
    }
    if (this.packageBuilderService.IsWheelAndTireSelected()) {
      let wheelIDs = this.packageBuilderService.getWheelIds();
      const installation = await this.settingService.getInstallations(this.packageBuilderService.getMakeYearModel(), wheelIDs.front, wheelIDs.rear).first().toPromise();
      if (installation.rear != null)
        this.addInstallationCard(installation.front, installation.rear);
      else
        this.addInstallationCard(installation.front, null);
    }
  }

  private addInstallationCard(frontMounting: LabourDetailsDtoResponse, rearMounting: LabourDetailsDtoResponse) {
    Helper.log('pdm.addInstallationCard');
    const mountingCard = new GenericSummaryCardDtoResponse();
    mountingCard.description = Constants.LABOUR_TYPE_MOUNTING_AND_BALANCING;
    mountingCard.productBrand = "";
    mountingCard.productType = "Accessory";
    mountingCard.recommended = false;
    mountingCard.visible = true;
    mountingCard.frontProduct = new ProductCardDtoResponse();
    mountingCard.frontProduct.freeWMB = frontMounting.id.startsWith("WMB") && this.packageBuilderService.freeWMB(Positions.FRONT);
    mountingCard.frontProduct.customerPrice = mountingCard.frontProduct.freeWMB ? "0.00" : frontMounting.customerPrice.toString();
    mountingCard.frontProduct.isBlem = false;
    mountingCard.frontProduct.shortSKU = frontMounting.sku;
    mountingCard.frontProduct.longSKU = frontMounting.id;
    mountingCard.frontProduct.details = new ProductCardDetailsDtoResponse();
    mountingCard.frontProduct.details.orientation = "Horizontal";
    const frontProdu = new ProductDetail();
    frontProdu.accessoryType = AccessoryCategory.Mounting;
    frontProdu.label = "Type";
    frontProdu.listViewOnly = false;
    frontProdu.value = "Mounting";
    mountingCard.frontProduct.details.details = new Array<ProductDetail>();
    mountingCard.frontProduct.details.details[0] = frontProdu;
    mountingCard.frontProduct.productImage = new ImageDetails();
    mountingCard.frontProduct.productImage.displayOrder = 1;
    mountingCard.frontProduct.productImage.thumbnailUrl = frontMounting.imageUrl;
    mountingCard.frontProduct.productImage.imageUrl = frontMounting.imageUrl; //mike
    mountingCard.frontProduct.retailPrice = frontMounting.retailPrice.toString();
    mountingCard.frontProduct.title = frontMounting.description;
    mountingCard.frontProduct.inventory = new InventoryDtoResponse;
    mountingCard.frontProduct.onHandDetails = new Array<InventoryDetailDtoResponse>();
    mountingCard.frontProduct.qtyPerWheel = 1;

    if (rearMounting) {
      mountingCard.rearProduct = new ProductCardDtoResponse();
      mountingCard.rearProduct.freeWMB = rearMounting.id.startsWith("WMB") && this.packageBuilderService.freeWMB(Positions.REAR);
      mountingCard.rearProduct.customerPrice = mountingCard.rearProduct.freeWMB ? "0.00" : rearMounting.customerPrice.toString();
      mountingCard.rearProduct.isBlem = false;
      mountingCard.rearProduct.shortSKU = rearMounting.sku;
      mountingCard.rearProduct.longSKU = rearMounting.id;
      mountingCard.rearProduct.details = new ProductCardDetailsDtoResponse();
      mountingCard.rearProduct.details.orientation = "Horizontal";
      const rearProdu = new ProductDetail();
      rearProdu.accessoryType = AccessoryCategory.Mounting;
      rearProdu.label = "Type";
      rearProdu.listViewOnly = false;
      rearProdu.value = "Mounting";
      mountingCard.rearProduct.details.details = new Array<ProductDetail>();
      mountingCard.rearProduct.details.details[0] = rearProdu;
      mountingCard.rearProduct.productImage = new ImageDetails();
      mountingCard.rearProduct.productImage.displayOrder = 1;
      mountingCard.rearProduct.productImage.imageUrl = rearMounting.imageUrl;
      mountingCard.rearProduct.productImage.thumbnailUrl = rearMounting.imageUrl;
      mountingCard.rearProduct.retailPrice = rearMounting.retailPrice.toString();
      mountingCard.rearProduct.title = rearMounting.description;
      mountingCard.rearProduct.inventory = new InventoryDtoResponse;
      mountingCard.rearProduct.onHandDetails = new Array<InventoryDetailDtoResponse>();
      mountingCard.rearProduct.qtyPerWheel = 1;
      mountingCard.rearProduct.position = PositionValues.REAR;
      mountingCard.frontProduct.position = PositionValues.FRONT;
    }
    else
      mountingCard.frontProduct.position = PositionValues.BOTH;

    this.packageBuilderService.addProductSummaryCard(mountingCard);
  }

  private addStuddingCard(frontStudding: LabourDetailsDtoResponse, rearStudding: LabourDetailsDtoResponse) {
    Helper.log('pdm.addStuddingCard');
    const studdingCard = new GenericSummaryCardDtoResponse();
    studdingCard.description = Constants.LABOUR_TYPE_STUDDING;
    studdingCard.productBrand = "";
    studdingCard.productType = "Accessory";
    studdingCard.recommended = false;
    studdingCard.visible = true;
    studdingCard.frontProduct = new ProductCardDtoResponse();
    studdingCard.frontProduct.customerPrice = frontStudding.customerPrice.toString();
    studdingCard.frontProduct.isBlem = false;
    studdingCard.frontProduct.shortSKU = frontStudding.sku;
    studdingCard.frontProduct.longSKU = frontStudding.id;
    studdingCard.frontProduct.details = new ProductCardDetailsDtoResponse();
    studdingCard.frontProduct.details.orientation = "Horizontal";
    const frontProd = new ProductDetail();
    frontProd.accessoryType = AccessoryCategory.Studding;
    frontProd.label = "Type";
    frontProd.listViewOnly = false;
    frontProd.value = "Studding";
    studdingCard.frontProduct.details.details = new Array<ProductDetail>();
    studdingCard.frontProduct.details.details[0] = frontProd;
    studdingCard.frontProduct.productImage = new ImageDetails();
    studdingCard.frontProduct.productImage.displayOrder = 1;
    studdingCard.frontProduct.productImage.imageUrl = frontStudding.imageUrl;
    studdingCard.frontProduct.productImage.thumbnailUrl = frontStudding.imageUrl;
    studdingCard.frontProduct.retailPrice = frontStudding.retailPrice.toString();
    studdingCard.frontProduct.title = frontStudding.description;
    studdingCard.frontProduct.inventory = new InventoryDtoResponse;
    studdingCard.frontProduct.onHandDetails = new Array<InventoryDetailDtoResponse>();
    studdingCard.frontProduct.qtyPerWheel = 1;

    if (rearStudding) {
      studdingCard.rearProduct = new ProductCardDtoResponse();
      studdingCard.rearProduct.customerPrice = rearStudding.customerPrice.toString();
      studdingCard.rearProduct.isBlem = false;
      studdingCard.rearProduct.shortSKU = rearStudding.sku;
      studdingCard.rearProduct.longSKU = rearStudding.id;
      studdingCard.rearProduct.details = new ProductCardDetailsDtoResponse();
      studdingCard.rearProduct.details.orientation = "Horizontal";
      const rearProd = new ProductDetail();
      rearProd.accessoryType = AccessoryCategory.Studding;
      rearProd.label = "Type";
      rearProd.listViewOnly = false;
      rearProd.value = "Studding";
      studdingCard.rearProduct.details.details = new Array<ProductDetail>();
      studdingCard.rearProduct.details.details[0] = rearProd;
      studdingCard.rearProduct.productImage = new ImageDetails();
      studdingCard.rearProduct.productImage.displayOrder = 1;
      studdingCard.rearProduct.productImage.imageUrl = rearStudding.imageUrl;
      studdingCard.rearProduct.productImage.thumbnailUrl = rearStudding.imageUrl;
      studdingCard.rearProduct.retailPrice = rearStudding.retailPrice.toString();
      studdingCard.rearProduct.title = rearStudding.description;
      studdingCard.rearProduct.inventory = new InventoryDtoResponse;
      studdingCard.rearProduct.onHandDetails = new Array<InventoryDetailDtoResponse>();
      studdingCard.rearProduct.qtyPerWheel = 1;
      studdingCard.rearProduct.position = PositionValues.REAR;
      studdingCard.frontProduct.position = PositionValues.FRONT;
    }
    else
      studdingCard.frontProduct.position = PositionValues.BOTH;

    this.packageBuilderService.addProductSummaryCard(studdingCard);
  }

  private setTabActive(tabName: string) {
    sessionStorage.setItem(tabName, "yes");
  }

  setupConfigurator(iconUrl: string) {
    if (iconUrl) {
      // Check if iconUrl matches iconfigurator regexp for security reasons
      if (this.regexp.test(iconUrl)) {
        const iconfiguratorParameter = iconUrl.substring(iconUrl.indexOf(Constants.ICONFIGURATOR_PAGE));
        let replacedUrl = window.location.protocol + '//';
        if (window.location.hostname.indexOf('localhost') > -1) {
          // djb:domain required by iconfigurator product key
          replacedUrl += "b2bdev.fastco.ca";
        } else {
          // djb:host includes port number
          //replacedUrl += window.location.hostname;
          replacedUrl += window.location.host;
        }
        replacedUrl += Constants.ICONFIGURATOR_LOCATION + iconfiguratorParameter;
        //replacedUrl needs to be modified to show color scroll.
        this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(replacedUrl);
      }
    }
  }

  //private getDismissReason(reason: any): string {
  //  if (reason === ModalDismissReasons.ESC) {
  //    return 'by pressing ESC';
  //  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
  //    return 'by clicking on a backdrop';
  //  } else {
  //    return `with: ${reason}`;
  //  }
  //}

  async postProductToCart() {
    // STUDDABLE TIRE
    let addStuddableService = false;
    let studFrontLabours: Product[] = null;
    let studRearLabours: Product[] = null;
    let studdableFrontProduct: Product = null;
    let studdableRearProduct: Product = null;

    if (this.card.frontProduct.studdable) {
      let _y = ['yes', 'oui'];
      const isStuddableFront = _y.includes(this.card.frontProduct.studdable.toLowerCase());// === 'yes';
      const isStuddableRear = this.card.rearProduct !== null && _y.includes(this.card.frontProduct.studdable.toLowerCase());// === 'yes';

      if (isStuddableFront || isStuddableRear) {
        let studLabour: LabourDetailsDtoResponse = null;

        if (isStuddableFront) {
          var frontStudding = this.card.frontProduct.labours.filter(x => x.details).find(y => y.type.toLowerCase() === 'studding');
          studLabour = frontStudding.details;

          var frontLabourModel = new LabourModel();
          frontLabourModel.labour = frontStudding;
          frontLabourModel.quantity = this.productModel.qty;

          studFrontLabours = [];
          studFrontLabours.push(Helper.labourModelToProduct(frontLabourModel));
          if (studFrontLabours.length > 0)
            studFrontLabours[0].parentId = this.productModel.id;

          studdableFrontProduct = new Product({
            id: this.productModel.id,
            warningNotes: this.card.frontProduct.warningNotes,
            quantity: this.productModel.qty,
            type: Constants.PRODUCT_TYPE_TIRE,
            pairNo: this.productModel.product.pairNo,
            labours: studFrontLabours.map(l => l.id)
          });
        }

        if (isStuddableRear) {
          var rearStudding = this.card.rearProduct.labours.filter(x => x.details).find(y => y.type.toLowerCase() === 'studding');

          if (studLabour === null)
            studLabour = rearStudding.details;

          var rearLabourModel = new LabourModel();
          rearLabourModel.labour = rearStudding;
          rearLabourModel.quantity = this.rearProductModel.qty;

          studRearLabours = [];
          studRearLabours.push(Helper.labourModelToProduct(rearLabourModel));
          if (studRearLabours.length > 0)
            studRearLabours[0].parentId = this.rearProductModel.id;

          studdableRearProduct = new Product({
            id: this.rearProductModel.id,
            warningNotes: this.card.rearProduct.warningNotes,
            quantity: this.rearProductModel.qty,
            type: Constants.PRODUCT_TYPE_TIRE,
            pairNo: this.productModel.product.pairNo,
            labours: studRearLabours.map(l => l.id)
          });
        }

        if (studLabour !== null) {
          const price = studLabour.customerPrice;
          const description = studLabour.description;
          const studMsg = this.translateService.instant('FC.ProductWarningsNotes.UpSellStuddable')
            .replace('[stud_description]', description)
            .replace('[stud_price]', price.toFixed(2));
          addStuddableService = await this.productNotesService.validateProductWarningsAckNormalPopup(
            [studMsg], null, 'FC.Popup.Labour.AddStudding', 'FC.Popup.Labour.DeclineStudding');
        }
      }
    }// END - STUDDABLE TIRE

    if (this.context === RouteContext.PRODUCTS_BY_SPEC || this.context === RouteContext.PRODUCTS_BY_BRAND) {
      // djb: Wheel not Wheels Constants.PRODUCT_TYPE_WHEEL)
      const pType = this.productModel.product.productType;
      if (pType === "Wheel" || pType === "Tire") {

        //Setup warning modal confirmations
        let warningsList = null;

        WarningsSetupService.setupWarnings(null, this.translateService, this.settingService, this.productModel.qty, this.rearProductModel ? this.rearProductModel.qty : null, this.card, false, false, this.mtlWheelDrillLeadTime).then(value => {
          warningsList = value;
          this.packageBuilderService.validateWarnings(warningsList.warnings).then(validated => {
            if (validated && warningsList.proceedToNextStep) {
              this.showWaiting = true;

              if (addStuddableService) {
                let arr = [];
                arr.push(studdableFrontProduct);
                arr.push(studFrontLabours[0]);

                if (this.rearProductModel) {
                  arr.push(studdableRearProduct);
                  arr.push(studRearLabours[0]);
                }
                this.addToCartService.postProductsToCart(arr);
              } else {
                if (this.rearProductModel) {
                  this.productService.postProductPairToCart(this.productModel.id,
                    this.productModel.qty, this.card.frontProduct.warningNotes, this.rearProductModel.id,
                    this.rearProductModel.qty, this.card.rearProduct.warningNotes, this.productModel.product.pairNo, this.productModel.product.productType);
                }
                else {
                  this.productService.postProductToCart(this.productModel.id,
                    this.productModel.qty, this.card.frontProduct.warningNotes, this.productModel.product.pairNo, this.productModel.product.productType, null);
                }
              }
            }
            else {
              this.showWaiting = false;
            }
          });
        });

      } else {
        //this.productService.postToCartWithCar(this.productModel.id,
        //  this.productModel.qty, null, null, this.productModel.product.warningNotes, this.mym);
        alert("postProduct feature not implemented");
      }
    } else if (this.context === RouteContext.SEARCH_BY_VEHICLE) {
      if (addStuddableService) {
        this.productService.postProductsToCart(studdableFrontProduct, studdableRearProduct, studFrontLabours, studRearLabours, this.mym);
      } else {
        if (this.rearProductModel) {
          this.productService.postToCartWithCar(this.productModel.id, this.productModel.qty, this.rearProductModel.id, this.rearProductModel.qty, this.card.frontProduct.warningNotes, this.card.rearProduct.warningNotes, this.mym, this.productModel.product.pairNo);
        } else {
          this.productService.postToCartWithCar(this.productModel.id, this.productModel.qty, null, null, this.card.frontProduct.warningNotes, null, this.mym, this.productModel.product.pairNo);
        }
      }
    }
  }

  get showRetailPrice(): boolean {
    return User.showRetailPrice;
  }

  get showDealerPrice(): boolean {
    return User.showDealerPrice;
  }

  get showInventory(): boolean {
    return User.showInventory;
  }

  get isFastcoUser(): boolean {
    return User.isFastcoRole;
  }

  get showCalgaryInventory(): boolean {
    let show: boolean = false;
    if (this.productModel.product.inventory.onHandQtyCal != null) {
      show = true;
    }
    else if (this.productModel.product.inventory.inTransitQtyCal != null) {
      show = true;
    }
    return show;
  }

  get showIsNew(): boolean {
    if (this.rearProductModel)
      return (this.productModel.product.isNew && !this.productModel.product.isSpecial) || (this.rearProductModel.product.isNew && !this.rearProductModel.product.isSpecial);
    return this.productModel.product.isNew && !this.productModel.product.isSpecial;
  }

  get showIsSpecial(): boolean {
    if (this.rearProductModel)
      return (this.productModel.product.isSpecial || this.rearProductModel.product.isSpecial);
    return this.productModel.product.isSpecial;
  }

  get showEH2(): boolean {
    return this.productModel.product.details.filter(e => e.value == "EH2").length >= 1;
  }
  get showEH2Plus(): boolean {
    return this.productModel.product.details.filter(e => e.value == "EH2+").length >= 1;
  }
  get showIsDirectFit(): boolean {
    if (this.rearProductModel)
      return this.productModel.product.isDirectFit && this.rearProductModel.product.isDirectFit;
    return this.productModel.product.isDirectFit;
  }

  get showIsAggressiveFitment(): boolean {
    if (this.rearProductModel)
      return (this.productModel.product.isAggressiveFitment || this.rearProductModel.product.isAggressiveFitment);
    return this.productModel.product.isAggressiveFitment;
  }

  get showIsDrilled(): boolean {
    if (this.rearProductModel)
      return (this.productModel.product.isDrilled || this.rearProductModel.product.isDrilled);
    return this.productModel.product.isDrilled;
  }

  get showIsBlem(): boolean {
    if (this.rearProductModel)
      return (this.productModel.product.isBlem || this.rearProductModel.product.isBlem);
    return this.productModel.product.isBlem;
  }

  get showConfirmedFitment(): boolean {
    if (this.rearProductModel)
      return this.productModel.product.confirmedFitment && this.rearProductModel.product.confirmedFitment;
    return this.productModel.product.confirmedFitment;
  }

  get isMYMWheel(): boolean {
    if (this.mym.isValid && this.productType == Constants.PRODUCT_TYPE_WHEEL)
      return true;
    return false;
  }

  get showAddCart(): boolean {
    return User.showAddCart;
  }
  changeSku(sku: string) {
    if (sku.indexOf("_") > 0) {
      this.product.longSKU = sku.substring(0, sku.indexOf("_"));
      this.rearProduct.longSKU = sku.substring(sku.indexOf("_") + 1);
    } else
      this.product.longSKU = sku;
    Helper.SkuList.setIndex(sku);
    this.getProductDetails();

    //console.log("Sku:" + sku);
    //console.log("Next:" + Helper.SkuList.next);
  }

  get canMovePrev(): boolean {
    return Helper.SkuList.canMovePrev;
  }

  movePrev(source: string): void {
    Helper.log(`${source} movePrev(left) `);
    if ((source == "swiperight") && (this.mobileBrowser)) {
      if (this.canMovePrev) {
        this.changeSku(Helper.SkuList.prev);
      }
    } else if (source != "swiperight") {
      if (this.canMovePrev) {
        this.changeSku(Helper.SkuList.prev);
      }
    }    
  }

  get canMoveNext(): boolean {

    if (Helper.SkuList.canMoveNext) {
      return (Helper.SkuList.next.startsWith(Constants.CUSTOMER_SIZE)) ? false : true;
    }
    else
      return false;
  }

  moveNext(source: string): void {
    Helper.log(`${source}: moveNext(right)`);
    if ((source == "swipeleft") && (this.mobileBrowser)) {                                                                                                                                                                                                                                                          
      if (this.canMoveNext) {
        this.changeSku(Helper.SkuList.next);
      }
    } else if (source != "swipeleft") {
      if (this.canMoveNext) {
        this.changeSku(Helper.SkuList.next);
      }
    }
  }

  isMobileBrowser(): void {
    //Helper.log(String(this.deviceService.isMobile()));
    this.mobileBrowser = this.deviceService.isMobile(); 
  }

  showEast(productModel: ProductDetailsModel): boolean {
    let result = false;
    if (productModel.product.inventory.onHandQtyPic !== null && productModel.product.inventory.onHandQtyPic != 0)
      result = true;
    else if (productModel.product.onHandDetails && productModel.product.onHandDetails.some(d => d.label === "FC.Inventory.AlternateWarehouse.PIC")) {
      productModel.product.onHandDetails.filter(d => d.label === "FC.Inventory.AlternateWarehouse.PIC").forEach(d => {
        if (d.qty !== null && d.qty != 0)
          result = true;
      });
    }
    return result;
  }

  getMTLInventory(productModel: ProductDetailsModel): string {
    let details: string = "";
    if (productModel.product.onHandDetails && productModel.product.onHandDetails.length > 0 &&
      productModel.product.onHandDetails.some(d => d.label.endsWith('MTL') || d.label.endsWith('PIC'))) {
      if (User.isFastcoRole) {
        productModel.product.onHandDetails.filter(d => d.label.endsWith('MTL') || d.label.endsWith('PIC')).forEach(d => {
          var qty = d.qty;
          if (productModel.product.onHandDetails.some(d => d.label.endsWith('MTL.hidden')))
            qty += productModel.product.onHandDetails.find(d => d.label.endsWith('MTL.hidden')).qty;
          var label = this.translateService.instant(d.label.replace('.AltDetail.MTL', '').replace('.AltDetail.PIC', '').replace('.WarehouseDetail.MTL', '').replace('.WarehouseDetail.PIC', ''));
          if (this.rearProductModel != null) {
            details += `<tr><td class="inv-label" style=" width: 75%; ">${label}</td><td style="text-align:center;" class="inv-item stockLabel-${this.normalizeQtyPipe.transform(qty)}">${this.normalizeQtyPipe.transform(qty)}</td><td style="text-align:center;"  class="rear-col"></td></tr>`;
          }
          else {
            details += `<tr><td class="inv-label" style=" width: 75%; ">${label}</td><td style="text-align:center;" class="inv-item stockLabel-${this.normalizeQtyPipe.transform(qty)}">${this.normalizeQtyPipe.transform(qty)}</td></tr>`;
          }
        });
      }
      else {
        productModel.product.onHandDetails.filter(d => (d.label.endsWith('MTL') && !d.label.endsWith('AltDetail.MTL')) || (d.label.endsWith('PIC') && !d.label.endsWith('AltDetail.PIC'))).forEach(d => {
          var qty = d.qty;
          if (productModel.product.onHandDetails.some(d => d.label.endsWith('MTL.hidden')))
            qty += productModel.product.onHandDetails.find(d => d.label.endsWith('MTL.hidden')).qty;
          var label = this.translateService.instant(d.label.replace('.WarehouseDetail.MTL', '').replace('.WarehouseDetail.PIC', ''));
          if (this.rearProductModel != null) {
            details += `<tr><td class="inv-label" style=" width: 75%; ">${label}</td><td style="text-align:center;" class="inv-item stockLabel-${this.normalizeQtyPipe.transform(qty)}">${this.normalizeQtyPipe.transform(qty)}</td><td style="text-align:center;"  class="rear-col"></td></tr>`;
          }
          else {
            details += `<tr><td class="inv-label" style=" width: 75%; ">${label}</td><td style="text-align:center;" class="inv-item stockLabel-${this.normalizeQtyPipe.transform(qty)}">${this.normalizeQtyPipe.transform(qty)}</td></tr>`;
          }
        });
      }
    } else {
      let qty: number = null;
      if (productModel.product.inventory.onHandQtyMtl !== null)
        qty = productModel.product.inventory.onHandQtyMtl;
      if (productModel.product.inventory.onHandQtyPic !== null) {
        if (qty === null)
          qty = 0;
        qty += productModel.product.inventory.onHandQtyPic;
      }
      if (this.rearProductModel != null) {
        details += `<tr><td class="inv-label" style=" width: 75%; ">${this.translateService.instant('FC.ProductDetail.Label.OnHand')}</td><td style="text-align:center;" class="inv-item stockLabel-${this.normalizeQtyPipe.transform(qty)}">${this.normalizeQtyPipe.transform(qty)}</td><td style="text-align:center;"  class="rear-col"></td></tr>`;
      }
      else {
        details += `<tr class=""><td class="inv-label" style=" width: 75%; ">${this.translateService.instant('FC.ProductDetail.Label.OnHand')}</td><td style="text-align:center;" class="inv-item stockLabel-${this.normalizeQtyPipe.transform(qty)}">${this.normalizeQtyPipe.transform(qty)}</td></tr>`;
      }
    }
    return details;

  }

  getCALInventory(productModel: ProductDetailsModel): string {
    let details: string = "";
    if (productModel.product.onHandDetails && productModel.product.onHandDetails.length > 0 &&
      productModel.product.onHandDetails.some(d => d.label.endsWith('CAL'))) {
      if (User.isFastcoRole) {
        productModel.product.onHandDetails.filter(d => d.label.endsWith('CAL')).forEach(d => {
          var qty = d.qty;
          if (productModel.product.onHandDetails.some(d => d.label.endsWith('CAL.hidden')))
            qty += productModel.product.onHandDetails.find(d => d.label.endsWith('CAL.hidden')).qty;
          var label = this.translateService.instant(d.label.replace('.AltDetail.CAL', '').replace('.WarehouseDetail.CAL', ''));
          if (this.rearProductModel != null) {
            details += `<tr><td class="inv-label" style=" width: 75%; ">${label}</td><td style="text-align:center;" class="inv-item stockLabel-${this.normalizeQtyPipe.transform(qty)}">${this.normalizeQtyPipe.transform(qty)}</td><td style="text-align:center;"  class="rear-col"></td></tr>`;
          }
          else {
            details += `<tr><td class="inv-label" style=" width: 75%; ">${label}</td><td style="text-align:center;" class="inv-item stockLabel-${this.normalizeQtyPipe.transform(qty)}">${this.normalizeQtyPipe.transform(qty)}</td></tr>`;
          }
        });
      }
      else {
        productModel.product.onHandDetails.filter(d => d.label.endsWith('CAL') && !d.label.endsWith('AltDetail.CAL')).forEach(d => {
          var qty = d.qty;
          if (productModel.product.onHandDetails.some(d => d.label.endsWith('CAL.hidden')))
            qty += productModel.product.onHandDetails.find(d => d.label.endsWith('CAL.hidden')).qty;
          var label = this.translateService.instant(d.label.replace('.WarehouseDetail.CAL', ''));
          if (this.rearProductModel != null) {
            details += `<tr><td class="inv-label" style=" width: 75%; ">${label}</td><td style="text-align:center;" class="inv-item stockLabel-${this.normalizeQtyPipe.transform(qty)}">${this.normalizeQtyPipe.transform(qty)}</td><td style="text-align:center;"  class="rear-col"></td></tr>`;
          }
          else {
            details += `<tr><td class="inv-label" style=" width: 75%; ">${label}</td><td style="text-align:center;" class="inv-item stockLabel-${this.normalizeQtyPipe.transform(qty)}">${this.normalizeQtyPipe.transform(qty)}</td></tr>`;
          }
        });
      }
    } else {
      var qty = productModel.product.inventory.onHandQtyCal;
      if (this.rearProductModel != null) {

        details += `<tr><td class="inv-label" style=" width: 75%; ">${this.translateService.instant('FC.ProductDetail.Label.OnHand')}</td><td style="text-align:center;" class="inv-item stockLabel-${this.normalizeQtyPipe.transform(qty)}">${this.normalizeQtyPipe.transform(qty)}</td><td style="text-align:center;"  class="rear-col"></td></tr>`;
      }
      else {

        details += `<tr class=""><td class="inv-label" style=" width: 75%; ">${this.translateService.instant('FC.ProductDetail.Label.OnHand')}</td><td style="text-align:center;" class="inv-item stockLabel-${this.normalizeQtyPipe.transform(qty)}">${this.normalizeQtyPipe.transform(qty)}</td></tr>`;
      }

    }
    return details;
  }

  popEmail() {
    //window.location.href = this.currentImageMailToURL;
    $('.productframe').css('z-index', '-1');
    this.displayConfigurator = true;

    var showConfirmedFitment = this.product.confirmedFitment;
    if (this.rearProduct)
      showConfirmedFitment = this.product.confirmedFitment && this.rearProduct.confirmedFitment;

    var specsLabels = {
      FCProductDetailLabelSKUNumber: this.translateService.instant('FC.ProductDetail.Label.SKUNumber'),
      FCProductDetailLabelPartNumber: this.translateService.instant('FC.ProductDetail.Label.PartNumber'),
      FCProductDetailLabelSize: this.translateService.instant('FC.ProductDetail.Label.Size'),
      FCProductDetailLabelPCD: this.translateService.instant('FC.ProductDetail.Label.PCD'),
      FCProductDetailLabelOffset: this.translateService.instant('FC.ProductDetail.Label.Offset'),
      FCProductDetailLabelBackspacing: this.translateService.instant('FC.ProductDetail.Label.Backspacing'),
      FCProductDetailLabelStance: this.translateService.instant('FC.ProductDetail.Label.Stance'),
      FCProductDetailLabelFinish: this.translateService.instant('FC.ProductDetail.Label.Finish'),
      FCProductDetailLabelBore: this.translateService.instant('FC.ProductDetail.Label.Bore'),
      FCProductDetailLabelSeat: this.translateService.instant('FC.ProductDetail.Label.Seat'),
      FCProductDetailLabelConstructionType: this.translateService.instant('FC.ProductDetail.Label.ConstructionType'),
      FCProductDetailWheelLabelMaxPSI: this.translateService.instant('FC.ProductDetail.Wheel.Label.MaxPSI'),
      FCProductDetailLabelLipSize: this.translateService.instant('FC.ProductDetail.Label.LipSize'),
      FCProductDetailLabelWeight: this.translateService.instant('FC.ProductDetail.Label.Weight'),
      FCProductDetailLabelLoadRating: this.translateService.instant('FC.ProductDetail.Label.LoadRating'),
      FCProductDetailLabelWinterApprovedFinish: this.translateService.instant('FC.ProductDetail.Label.WinterApprovedFinish'),
      FCProductDetailLabelCategory: this.translateService.instant('FC.ProductDetail.Label.Category'),
      FCProductDetailLabelMounting: this.translateService.instant('FC.ProductDetail.Label.Mounting'),
      FCProductDetailLabelRunflatCertified: this.translateService.instant('FC.ProductDetail.Label.RunflatCertified'),
      FCProductDetailLabelGTIN: this.translateService.instant('FC.ProductDetail.Label.GTIN'),
    }

    var iconTooltip = {
      FCIconToolTipAllSeason: this.translateService.instant('FC.Icon.ToolTip.AllSeason'),
      FCIconToolTipStaggered: this.translateService.instant('FC.Icon.ToolTip.Staggered'),
      FCIconToolTipSummer: this.translateService.instant('FC.Icon.ToolTip.Summer'),
      FCIconToolTipWinterApproved: this.translateService.instant('FC.Icon.ToolTip.WinterApproved'),
      FCIconToolTipWinterTire: this.translateService.instant('FC.Icon.ToolTip.WinterTire'),
      FCIconToolTipWheelAllSeason: this.translateService.instant('FC.Icon.ToolTip.WheelAllSeason'),
      FCIconToolTipWheelSummer: this.translateService.instant('FC.Icon.ToolTip.WheelSummer')
    }

    var directFit = {
      label: this.translateService.instant('FC.Label.Flags.DirectFit'),
    }

    var aggressiveFitment = {
      label: this.translateService.instant('FC.Label.Flags.AggressiveFitment'),
    }

    var drilled = {
      label: this.translateService.instant('FC.Label.Flags.Drilled'),
    }

    var blem = {
      label: this.translateService.instant('FC.Label.Flags.Blemished'),
    }

    var runflatCertified = {
      label: this.translateService.instant('FC.Label.Flags.RunflatCertified'),
    }

    var customerID = sessionStorage.getItem("customerID");

    var _mym: any = null;
    if (this.mym.isValid) {
      _mym = Object.assign({}, this.mym);
      _mym['customer'] = customerID;
    }

    var json = {
      mym: _mym,
      frontLongSKU: this.product.longSKU,
      rearLongSKU: this.rearProduct ? this.rearProduct.longSKU : null,
      title: this.productModel.product.productBrand + ' ' + this.getTitle(),
      brandLogo: this.brandLogoURL,
      show_Confirmed_Fitment: showConfirmedFitment,
      iconfig_vehiclebackimg: '',
      iconfig_vehiclefrontimg: '',
      iconfig_wheelR: null,
      iconfig_wheelF: null,
      email_recepient: '',
      specs_Label: specsLabels,
      direct_Fit: directFit,
      aggressive_Fitment: aggressiveFitment,
      drilled: drilled,
      blem: blem,
      runflat_Certified: runflatCertified,
      icon_Tooltip: iconTooltip,
      show_Wheels: true,
      customerID: customerID
    }

    const modalRef = this.modalService.open(ProductDetailsEmailModal, { windowClass: 'product-configurator-email-modal', size: 'md' });
    modalRef.componentInstance.safeURL = this.safeURL
    modalRef.componentInstance.RequestJson = json;

    modalRef.result.then(
      () => {
        this.displayConfigurator = false;
      }, () => {
        this.displayConfigurator = false;
      });
  }

  get isMissingMSRP(): boolean {
    let result = false;

    if (this.productModel.product.retailPrice === "9999.99")
      result = true;
    else if (this.rearProductModel && this.rearProductModel.product && (this.rearProductModel.product.retailPrice === "9999.99"))
      result = true;

    return result;
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

}

@Component({
  selector: 'app-product-details-email-modal',
  templateUrl: './product-details-email-modal.html',
  styleUrls: ['./product-details-modal.component.css'],
})

export class ProductDetailsEmailModal implements OnInit {
  @Input() RequestJson: any;
  @Input() safeURL: SafeUrl;
  isReady: boolean = true;
  emailAddress: string = '';

  constructor(public activeModal: NgbActiveModal, private productConfiguratorModalService: ProductConfiguratorModalService) { }

  ngOnInit() { }

  mailTo() {

    if (this.emailAddress !== '') {
      var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      if (regexp.test(this.emailAddress)) {

        this.isReady = false;
        this.RequestJson.email_recepient = this.emailAddress;

        let iconfigvehiclebackimg: any;
        let iconfigvehiclefrontimg: any;
        let iconfigwheelrear: any;
        let iconfigwheelfront: any;
        let iconfigwheelR: any;
        let iconfigwheelF: any;

        if (this.safeURL) {
          const iframe = (<HTMLIFrameElement>document.getElementById('iconfiguratorFrame'));
          var innerDoc = (iframe.contentDocument) ? iframe.contentDocument : iframe.contentWindow.document;

          iconfigvehiclebackimg = <HTMLImageElement>innerDoc.getElementById('iconfig_vehiclebackimg');
          iconfigvehiclefrontimg = <HTMLImageElement>innerDoc.getElementById('iconfig_vehiclefrontimg');
          iconfigwheelrear = <HTMLImageElement>innerDoc.getElementById('iconfig_wheelrear');
          iconfigwheelfront = <HTMLImageElement>innerDoc.getElementById('iconfig_wheelfront');
          iconfigwheelR = <HTMLImageElement>innerDoc.getElementById('iconfig_wheelR');
          iconfigwheelF = <HTMLImageElement>innerDoc.getElementById('iconfig_wheelF');
        }

        const iconfig_wheelR = {
          img_src: this.safeURL ? iconfigwheelR.src : '',
          img_style: this.safeURL ? `style='height:${iconfigwheelR.style.height}; width:${iconfigwheelR.style.width}; transform:${iconfigwheelR.style.transform}'` : '',
          div_style: this.safeURL ? `style='display:${iconfigwheelrear.style.display}; top:${iconfigwheelrear.style.top}; left:${iconfigwheelrear.style.left}; z-index:${iconfigwheelrear.style.zIndex}'` : ''
        };

        const iconfig_wheelF = {
          img_src: this.safeURL ? iconfigwheelF.src : '',
          img_style: this.safeURL ? `style='height:${iconfigwheelF.style.height}; width:${iconfigwheelF.style.width}; transform:${iconfigwheelF.style.transform}'` : '',
          div_style: this.safeURL ? `style='display:${iconfigwheelfront.style.display}; top:${iconfigwheelfront.style.top}; left:${iconfigwheelfront.style.left}; z-index:${iconfigwheelfront.style.zIndex}'` : ''
        }

        let hasConfiguratorImage = false;
        if (iconfigvehiclebackimg && iconfigvehiclebackimg.src !== '' && iconfigvehiclebackimg.src.indexOf('images') !== -1)
          hasConfiguratorImage = true;

        this.RequestJson.iconfig_vehiclebackimg = hasConfiguratorImage ? iconfigvehiclebackimg.src : '';
        this.RequestJson.iconfig_vehiclefrontimg = this.safeURL && iconfigvehiclefrontimg ? iconfigvehiclefrontimg.src : '';
        this.RequestJson.iconfig_wheelR = iconfig_wheelR;
        this.RequestJson.iconfig_wheelF = iconfig_wheelF;
        this.RequestJson.isMicrosite = (sessionStorage.getItem("isMicrosite").toLowerCase() === "true");
        this.productConfiguratorModalService.SendConfiguratorEmail(this.RequestJson).then(() => {
          this.isReady = true;
          this.emailAddress = '';
          this.activeModal.dismiss('Cross click');
        });
      }
    }
  }
}
